export enum PaymentType {
    paymentservice = 'paymentservice',
    easyaccount = 'easyaccount',
    digitalpost = 'digitalpost',
}
